export const RESET_STATE = 'RESET_STATE'

export const INTERNET_CONNECTED = 'INTERNET_CONNECTED'
export const INTERNET_DISCONNECTED = 'INTERNET_DISCONNECTED'

export const API_RATELIMIT_LOCKED = 'API_RATELIMIT_LOCKED'
export const API_RATELIMIT_UNLOCKED = 'API_RATELIMIT_UNLOCKED'

export const UPDATE_IDTOKEN = 'UPDATE_IDTOKEN'
export const UPDATE_IDTOKEN_EXPIRED = 'UPDATE_IDTOKEN_EXPIRED'
export const UPDATE_DEALER_LOGO = 'UPDATE_DEALER_LOGO'

export const SET_VERIFICATION_RESULT = 'SET_VERIFICATION_RESULT'
export const SET_VERIFICATION_ISCOMPLETED = 'SET_VERIFICATION_ISCOMPLETED'

export const GET_VERIFICATION_REQUEST = 'GET_VERIFICATION_REQUEST'
export const GET_VERIFICATION_SUCCESS = 'GET_VERIFICATION_SUCCESS'
export const GET_VERIFICATION_FAILURE = 'GET_VERIFICATION_FAILURE'

export const GET_VERIFICATION_LIVESNAPSHOTURL_REQUEST = 'GET_VERIFICATION_LIVESNAPSHOTURL_REQUEST'
export const GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS = 'GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS'
export const GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE = 'GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE'

export const GET_VERIFICATION_LIVESNAPSHOT_REQUEST = 'GET_VERIFICATION_LIVESNAPSHOT_REQUEST'
export const GET_VERIFICATION_LIVESNAPSHOT_SUCCESS = 'GET_VERIFICATION_LIVESNAPSHOT_SUCCESS'
export const GET_VERIFICATION_LIVESNAPSHOT_FAILURE = 'GET_VERIFICATION_LIVESNAPSHOT_FAILURE'

export const GET_VERIFICATION_EVENT_REQUEST = 'GET_VERIFICATION_EVENT_REQUEST'
export const GET_VERIFICATION_EVENT_SUCCESS = 'GET_VERIFICATION_EVENT_SUCCESS'
export const GET_VERIFICATION_EVENT_FAILURE = 'GET_VERIFICATION_EVENT_FAILURE'

export const GET_VERIFICATION_EVENT_MEDIAS_REQUEST = 'GET_VERIFICATION_EVENT_MEDIAS_REQUEST'
export const GET_VERIFICATION_EVENT_MEDIAS_SUCCESS = 'GET_VERIFICATION_EVENT_MEDIAS_SUCCESS'
export const GET_VERIFICATION_EVENT_MEDIAS_FAILURE = 'GET_VERIFICATION_EVENT_MEDIAS_FAILURE'

export const GET_VERIFICATION_EVENT_RECORD_REQUEST = 'GET_VERIFICATION_EVENT_RECORD_REQUEST'
export const GET_VERIFICATION_EVENT_RECORD_SUCCESS = 'GET_VERIFICATION_EVENT_RECORD_SUCCESS'
export const GET_VERIFICATION_EVENT_RECORD_FAILURE = 'GET_VERIFICATION_EVENT_RECORD_FAILURE'

export const GET_VERIFICATION_PRIVACYSTATUS_REQUEST = 'GET_VERIFICATION_PRIVACYSTATUS_REQUEST'
export const GET_VERIFICATION_PRIVACYSTATUS_SUCCESS = 'GET_VERIFICATION_PRIVACYSTATUS_SUCCESS'
export const GET_VERIFICATION_PRIVACYSTATUS_FAILURE = 'GET_VERIFICATION_PRIVACYSTATUS_FAILURE'

export const CREATE_VERIFICATION_RESPONSE_REQUEST = 'CREATE_VERIFICATION_RESPONSE_REQUEST'
export const CREATE_VERIFICATION_RESPONSE_SUCCESS = 'CREATE_VERIFICATION_RESPONSE_SUCCESS'
export const CREATE_VERIFICATION_RESPONSE_FAILURE = 'CREATE_VERIFICATION_RESPONSE_FAILURE'

export const SET_VERIFICATION_PRIVACY_DISABLED_DURATION_REQUEST = 'SET_VERIFICATION_PRIVACY_DISABLED_DURATION_REQUEST'
export const SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS = 'SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS'
export const SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE = 'SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE'

export const GET_VERIFICATION_SITE_VERIFICATION_DURATION_REQUEST = 'GET_VERIFICATION_SITE_VERIFICATION_DURATION_REQUEST'
export const GET_VERIFICATION_SITE_VERIFICATION_DURATION_SUCCESS = 'GET_VERIFICATION_SITE_VERIFICATION_DURATION_SUCCESS'
export const GET_VERIFICATION_SITE_VERIFICATION_DURATION_FAILURE = 'GET_VERIFICATION_SITE_VERIFICATION_DURATION_FAILURE'

export const GET_PSAP_REQUEST = 'GET_PSAP_REQUEST'
export const GET_PSAP_SUCCESS = 'GET_PSAP_SUCCESS'
export const GET_PSAP_FAILURE = 'GET_PSAP_FAILURE'

export const GET_PSAP_LIVESNAPSHOTURL_REQUEST = 'GET_PSAP_LIVESNAPSHOTURL_REQUEST'
export const GET_PSAP_LIVESNAPSHOTURL_SUCCESS = 'GET_PSAP_LIVESNAPSHOTURL_SUCCESS'
export const GET_PSAP_LIVESNAPSHOTURL_FAILURE = 'GET_PSAP_LIVESNAPSHOTURL_FAILURE'

export const GET_PSAP_LIVESNAPSHOT_REQUEST = 'GET_PSAP_LIVESNAPSHOT_REQUEST'
export const GET_PSAP_LIVESNAPSHOT_SUCCESS = 'GET_PSAP_LIVESNAPSHOT_SUCCESS'
export const GET_PSAP_LIVESNAPSHOT_FAILURE = 'GET_PSAP_LIVESNAPSHOT_FAILURE'

export const GET_PSAP_EVENT_REQUEST = 'GET_PSAP_EVENT_REQUEST'
export const GET_PSAP_EVENT_SUCCESS = 'GET_PSAP_EVENT_SUCCESS'
export const GET_PSAP_EVENT_FAILURE = 'GET_PSAP_EVENT_FAILURE'

export const GET_PSAP_EVENT_MEDIAS_REQUEST = 'GET_PSAP_EVENT_MEDIAS_REQUEST'
export const GET_PSAP_EVENT_MEDIAS_SUCCESS = 'GET_PSAP_EVENT_MEDIAS_SUCCESS'
export const GET_PSAP_EVENT_MEDIAS_FAILURE = 'GET_PSAP_EVENT_MEDIAS_FAILURE'

export const GET_PSAP_EVENT_RECORD_REQUEST = 'GET_PSAP_EVENT_RECORD_REQUEST'
export const GET_PSAP_EVENT_RECORD_SUCCESS = 'GET_PSAP_EVENT_RECORD_SUCCESS'
export const GET_PSAP_EVENT_RECORD_FAILURE = 'GET_PSAP_EVENT_RECORD_FAILURE'

export const CHECK_EVENT_RECORD_CODEC_DONE = 'CHECK_MONITORING_EVENT_RECORD_CODEC_DONE'

export const REMAIN_VERIFICATION_TIME_UPDATE = 'REMAIN_VERIFICATION_TIME_UPDATE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js